import { Injectable } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { DisplayService } from './display.service';

@Injectable({ providedIn: 'root' })
export class TroubleshootCopyService {

  constructor(private readonly clipboard: Clipboard,
              private readonly displayService: DisplayService) { }

  async copyTroubleshootInfo(): Promise<void> {
    const response = this.displayService.lastErrorResponse;
    const isHtml = response?.contentType?.includes('text/html');
    if (isHtml) {
      const htmlBody: string = response.body;
      try {
        const htmlBlob = new Blob([htmlBody], { type: 'text/html' });
        const tempEl = document.createElement('div');
        tempEl.innerHTML = htmlBody;
        const textBlob = new Blob([tempEl.textContent || ''], { type: 'text/plain' });
        await navigator.clipboard.write([new ClipboardItem({ 'text/html': htmlBlob, 'text/plain': textBlob })]);
      } catch {
        this.clipboard.copy(htmlBody);
      }
    } else {
      const body = response?.body;
      const errorCode = body?.errorCode ?? body?.data?.errorCode ?? '';
      const errorMessage = body?.errorMessage ?? body?.data?.errorMessage ?? '';
      const lines: string[] = [];
      lines.push(
        `Timestamp: ${this.displayService.lastTransaction ?? ''}`,
        `Client Transaction: ${this.displayService.clientTransactionId ?? ''}`,
        `User: ${this.displayService.userName ?? ''}`,
        `Error Code: ${errorCode}`,
        `Error Message: ${errorMessage}`
      );
      this.clipboard.copy(lines.join('\n'));
    }
  }
}
